import React from "react";

const MutationDetectionDescription = () => {
  return (
    <div id="assy-creation-description">
      <h2>Assay Description</h2>
      <p>
        ddPCR Mutation detection assays can be found and purchased on
        Bio-Rad.com/digital-assays. A wet-lab validated mutation detection assay
        is returned if available, or an assay is designed instantly for your
        target. Wet-lab validated mutation detection assays detect mutant DNA
        present at 0.1% in a background of WT DNA in one well. An even better
        sensitivity of 0.005–0.1% can generally be achieved by using multiple
        reaction wells. Browse list of wet-lab validated{" "}
        <a href="/webroot/web/pdf/lsr/literature/Bulletin_7144.pdf">
          Mutation Detection Assays
        </a>
        .
      </p>
      <p>
        Mutation detection assays can be designed instantly for over 4 million
        mutations, listed in the COSMIC database, on Bio-Rad’s Digital Assay
        Site. Built by the experts in digital PCR at Bio-Rad's Digital Biology
        Center, the Bio-Rad Digital Assay Site design engine takes into
        consideration everything from GC content and Tm, to primer placement and
        probe length, even genome specificity when designing an assay for you.
      </p>
      <h3>Key Benefits</h3>
      <ul>
        <li>Wet-lab validated assays available for more than 200 targets</li>
        <li>
          Wet-lab validated assays guaranteed to work when used as instructed
        </li>
        <li>Validation data available for review and download</li>
        <li>
          Assays designed instantly for targets and sequences for which
          validated assays are not available
        </li>
        <li>
          Suitable for use with circulating tumor DNA, liquid biopsy, and FFPE
          and other tissue samples
        </li>
        <li>Orderable in single-tube&nbsp;or two-tube formats</li>
        <li>Positive control sequences provided</li>
      </ul>
      <h3>Sample Data</h3>
      <img
        src="//www.bio-rad.com/webroot/web/images/lsr/products/amplification_pcr/product_detail/global/6512-MD-A.jpg"
        width="630"
        height="329"
        caption="false"
      />
      <br />
      <img
        src="//www.bio-rad.com/webroot/web/images/lsr/products/amplification_pcr/product_detail/global/6512-MD-B.jpg"
        width="630"
        height="329"
        caption="false"
      />
      <br />
      <img
        src="//www.bio-rad.com/webroot/web/images/lsr/products/amplification_pcr/product_detail/global/6512-MD-C.jpg"
        alt=""
        width="630"
        height="329"
      />
      <br />
      <p>
        <small>
          <strong>
            High sensitivity of PrimePCR ddPCR mutation detection assays provide
            precise quantification of <em>JAK2 V617F</em> mutation in the
            presence of wild-type DNA. A
          </strong>
          , 2-D fluorescence amplitude plot shows duplicate wells of a mixed
          mutant: wild-type sample across multiple percentage mutant blends. The
          black cluster on the plot represents the negative droplets, the green
          cluster represents the droplets that are positive for wild-type DNA
          only, the blue cluster represents the droplets that are positive for
          mutant DNA only, and the orange cluster represents the droplets that
          are positive for both wild-type and mutant targets. <strong>B</strong>
          , 2-D fluorescence amplitude plot shows duplicate wells of a
          wild-type–only sample.
          <strong>C</strong>, fractional abundance plot shows the percentage
          frequency (orange markers) of the mutant DNA in a wild-type DNA
          background. All error bars are generated by QuantaSoft software and
          represent the 95% confidence interval.
        </small>
      </p>
      <h3>Packaging Options</h3>
      <p>
        ddPCR Mutation Detection Assays are available in single tube or two-tube
        formats.
      </p>
      <p>
        <strong>
          Single-tube format
          <br />
        </strong>
      </p>
      <p>
        The single-tube formats of the ddPCR Mutation Detection Assays contain a
        set of primers, a mutant, and wild-type probe. The single tube format
        assays are 20X concentrated, ready-to-use-primer-probe mix optimized for
        use with ddPCR Supermix for Probes (no dUTP). Each assay contains 18 uM
        each primer and 5uM each probe. The single-tube formats provide added
        convenience as the mutant and WT probes are pre-mixed and allow for the
        addition of an extra sample in the ddPCR reaction.
      </p>

      <p>
        <strong>Two-tube formats</strong>
      </p>
      <p>The mutant and WT probes are provided separately.</p>
    </div>
  );
};

export default MutationDetectionDescription;
